import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AwardFlightStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M18.7139 9.16309C18.7139 5.67488 15.7426 2.78613 12 2.78613C8.25738 2.78613 5.28613 5.67488 5.28613 9.16309C5.28632 13.1819 8.31787 16.2139 12 16.2139C15.6863 16.2139 18.7137 13.242 18.7139 9.16309ZM20.2861 9.16309C20.2859 14.0658 16.5977 17.7861 12 17.7861C7.3981 17.7861 3.71406 13.9971 3.71387 9.16309C3.71387 4.73956 7.45836 1.21387 12 1.21387C16.5417 1.21387 20.2861 4.73956 20.2861 9.16309Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.036 6.83478C13.362 6.50874 14.0435 5.85546 14.3498 5.68401C14.749 5.46055 15.1485 5.41771 15.5922 5.68401C15.6318 5.70779 15.665 5.74097 15.6888 5.7806C15.9587 6.23059 15.9145 6.62982 15.6888 7.02805C15.5163 7.33233 14.8626 8.01154 14.5374 8.33684L13.9744 8.90017L15.0211 11.5799C15.115 11.9365 15.0124 12.3162 14.7517 12.577L14.4452 12.8835C14.385 12.9436 14.301 12.9734 14.2165 12.9644C14.1319 12.9555 14.056 12.9088 14.0098 12.8374L12.2853 10.4023L11.1593 11.5288L11.3727 12.6532C11.3821 12.7383 11.3525 12.823 11.2919 12.8835L10.7581 13.4175C10.6941 13.4815 10.6032 13.5109 10.5139 13.4964C10.4246 13.4819 10.3477 13.4253 10.3072 13.3444L9.54838 11.8262L8.03064 11.0672C7.94969 11.0267 7.89313 10.9497 7.87864 10.8604C7.86414 10.771 7.89348 10.6801 7.95748 10.6161L8.49136 10.0821C8.55183 10.0216 8.6365 9.99187 8.72149 10.0013L9.84558 10.2145L10.9716 9.08801L8.53749 7.36361C8.46611 7.3174 8.41942 7.24139 8.41046 7.15681C8.4015 7.07222 8.43124 6.98811 8.49136 6.92797L8.79788 6.62142C9.05857 6.36066 9.43809 6.25804 9.79459 6.35188L12.473 7.39813L13.036 6.83478Z"
				fill="currentColor"
			/>
			<path
				d="M17.7402 21.877C17.7831 22.1347 17.6879 22.3964 17.4902 22.5674C17.2925 22.7382 17.0203 22.7935 16.7715 22.7139L12 21.1865L7.22852 22.7139C6.97965 22.7935 6.70747 22.7382 6.50977 22.5674C6.31212 22.3964 6.21692 22.1347 6.25977 21.877L7.25977 15.877L8.74023 16.123L7.94141 20.9111L11.7715 19.6855L11.8848 19.6592C11.9994 19.6414 12.1171 19.6499 12.2285 19.6855L16.0576 20.9111L15.2598 16.123L16.7402 15.877L17.7402 21.877Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AwardFlightStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AwardFlightStrokeIcon;
